import { LiveAnnouncer } from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatChipInputEvent, MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { map, Observable, startWith, Subject, takeUntil } from 'rxjs';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { luhnValidator } from 'src/app/shared/Validators/luhnValidator';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption, MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { CardNumberFormatPipe } from '../../../../shared/pipes/card-number-format.pipe';
import { ErrorStateMatcher } from '@angular/material/core';

export class CardErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: any): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

@Component({
    selector: 'app-corporate-cards',
    templateUrl: './corporate-cards.component.html',
    styleUrls: ['./corporate-cards.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatInput, MatError, MatSuffix, MatSelect, NgFor, MatOption, MatRadioGroup, MatRadioButton, MatCheckbox, MatChipGrid, MatChipRow, MatChipRemove, MatChipInput, MatAutocompleteTrigger, MatAutocomplete, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CamEmptyStateComponent, CdkScrollable, MatDialogContent, MatDialogActions, AsyncPipe, CardNumberFormatPipe]
})
export class CorporateCardsComponent implements OnInit, OnDestroy {
  matcher = new CardErrorStateMatcher();
  displayedColumns: string[] = ['Card Name', 'Card Type', 'Name on Card', 'Card Expiry', 'Currency', 'Rule applied on', 'Product', 'Action'];
  years: { value: number, isDisabled: boolean }[] = [];
  months: { value: string; name: string, index: number }[] = [];
  Addnew: boolean = false;
  editMode: boolean = false;
  /** True when card number field contains the masked value from the server (edit mode, unchanged). */
  isCardMasked: boolean = false;
  /** Original unmasked card number stored when entering edit mode. */
  private originalCardNumber: string = '';
  sauserId!: string;
  appliedOnValue: number = 0;
  corporateCardForm!: FormGroup;
  associatedRuleAppliedOn: any[] = [];
  guid: any;
  isLoading = true;
  ruleAppliedOnName!: any;

  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  currentItem: any;

  commonObjPipes: any = {
    GetAllCorporateCardDetails: { pipe: [], all: [] },
    GetCardType: { pipe: [], all: [] },
    GetCardOption: { pipe: [], all: [] },
    GetRuleAppliesOn: { pipe: [], all: [] },
    associatedRuleAppliedOn: { pipe: [], all: [] }
  }

  //chips dropdown
  separatorKeysCodes: number[] = [ENTER, COMMA];
  ruleAppliedFor = new FormControl('');
  filteredAssocatedWithRule: Observable<any[]>;
  associateRuleName: string[] = [];
  selectedAssoicatedRuleIdMap: { [key: number]: boolean } = {}
  getProdectData: { pipe: any[]; all: any[] } = {
    pipe: [
      { Product_code: 'AIR ', Is_Access: true, Product_Name: 'Flight' },
      { Product_code: 'OTH ', Is_Access: true, Product_Name: 'Other Products' }
    ],
    all: [
      { Product_code: 'AIR ', Is_Access: true, Product_Name: 'Flight' },
      { Product_code: 'CCR ', Is_Access: true, Product_Name: 'Car' },
      { Product_code: 'HHL ', Is_Access: true, Product_Name: 'Hotel' },
      { Product_code: 'OTH ', Is_Access: true, Product_Name: 'Other Products' }
    ]
  };
  // allFruits: string[] = ['Apple', 'Lemon', 'Lime', 'Orange', 'Strawberry'];

  @ViewChild('fruitInput') fruitInput!: ElementRef<HTMLInputElement>;

  announcer = inject(LiveAnnouncer);
  private destroy$ = new Subject<void>();
  content: any;
  dictionaryContent:any;
  constructor(
    private _camService: CamService,
    private crypto: CryptoService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private _ToastrApiService: ToastrApiService,
    public _CommonService: CommonService,
    private _CompanyManagementService: CompanyManagementService,
    private contentService: CompanyManagementContentService,
    private readonly dictionaryContentService:DisctionaryContent
  ) {

    this.corporateCardForm = this.fb.group({
      queryNo: [1],
      guid: [null],
      cardName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]],
      cardOption: ['', [Validators.required]],
      cardType: ['', [Validators.required]],
      cardHolderName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(50)]],
      cardNumber: ['', [Validators.required, luhnValidator()]],
      expiryMonth: [null, [Validators.required]],
      expiryYear: [null, [Validators.required]],
      isVirtualCard: [true, [Validators.required]],
      islodge: true,
      isChargeAtMerchant: [false],
      ruleAppliedOn: [0, [Validators.required]],
      product: ['', [Validators.required]],
      ruleAppliedFor: ['', [Validators.required]], // <-- Fix applied
      isPersonalCard: [false]
    },
      { validator: this.atLeastOneCheckboxValidator });

    this.initializeMonthsAndYears()

    // this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
    //     startWith(null),
    //     map((fruit: string | null) => (fruit ? this._filter(fruit) : this.commonObjPipes.associatedRuleAppliedOn.pipe.slice())),
    //   );

    this.filteredAssocatedWithRule = this.ruleAppliedFor.valueChanges.pipe(
      startWith(null),
      map((value: string | null) => {
        if (typeof value === 'string') {
          return this._filter(value);
        } else {
          return this.commonObjPipes.associatedRuleAppliedOn.pipe.slice();
        }
      })
    );
  }

  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = res;
    });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.dictionaryContent = res;
    })
    this.sauserId = this.crypto.getValueFromKey('USERID') as string;
    this.getCorporateCardsList()

    this.corporateCardForm.get('cardNumber')?.valueChanges.subscribe((val) => {
      // When user starts typing a new card number, restore full validators
      if (this.isCardMasked && val && !/\*/.test(val)) {
        this.isCardMasked = false;
        this.corporateCardForm.get('cardNumber')?.setValidators([Validators.required, luhnValidator()]);
        this.corporateCardForm.get('cardNumber')?.updateValueAndValidity({ emitEvent: false });
      }
      this.checkCardTypeValidation();
    });

    this.corporateCardForm.get('cardType')?.valueChanges.subscribe(() => {
      this.checkCardTypeValidation();
    });
  }

  handleEvent(event: string, template?: TemplateRef<any>) {
    if (template && this.getUserRole() === 'Admin') {
      this.dialog.open(template, {
        width: '638px',
        disableClose: false,
        autoFocus: false
      });
    }
    if (event.includes('corporate-cards')) {
      this._CompanyManagementService.company_management_corporateCard('Add Link','Add', this.commonObjPipes.GetAllCorporateCardDetails.pipe.length)//GTM use
      this.Addnew = true;
    }
  }

  isEmptyObject(obj: any): boolean {
    return obj && Object.keys(obj).length === 0;
  }

  getProductName(productCode: string | undefined | null): string {
    if (productCode == null || productCode === '') return 'NA';
    const code = String(productCode).trim();
    const product = this.getProdectData.all.find(
      (p: any) => (p.Product_code && String(p.Product_code).trim()) === code
    );
    return product?.Product_Name ?? productCode ?? 'NA';
  }

  getCorporateCardsList() {
    this.isLoading = true;
  
    this._camService.getCorporateCards(this.sauserId, this.appliedOnValue)
      .then((res) => {  
        if (res.status == "Success") {
          const filteredRuleAppliesOn = res.data.GetRuleAppliesOn.filter(
            (item: any) => item.Name !== 'Traveler'
          );
  
          this.bindLists('GetAllCorporateCardDetails', res.data.GetAllCorporateCardDetails);
          this.bindLists('GetCardType', res.data.GetCardType);
          this.bindLists('GetCardOption', res.data.GetCardOption);
          this.bindLists('GetRuleAppliesOn', filteredRuleAppliesOn);
        }
      })
      .catch((error) => {
        console.error(error);
         const message =
          error?.error?.message ||
          error?.message ||
          'Something went wrong. Please try again.';
        this._CompanyManagementService.view_error_message(message,error?.code);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  bindLists(key: string, lists: any[]) {
    this.commonObjPipes[key].pipe = lists;
    this.commonObjPipes[key].all = lists;
  }



  getRuleAppliedOnName(id: number): string {
    const ruleList = this.commonObjPipes?.GetRuleAppliesOn?.pipe; // Ensure it's an array
    if (!Array.isArray(ruleList)) {
      return 'Unknown';
    }

    const rule = ruleList.find(item => item.ID === id);
    if (!rule) {
      return 'Unknown';
    }

    // ✅ Custom condition: if rule name is "Corporate-Branch"
    if (rule.Name === 'Corporate-Branch') {
      return 'Corporate office location';
    }

    // Default case
    return rule.Name;
  }




  onRuleAppliedOnChange1(item: any, isEditMode: boolean = false): Promise<void> {
    this.associateRuleName = [];

    return new Promise((resolve, reject) => {
      this.ruleAppliedOnName = this.commonObjPipes.GetRuleAppliesOn.pipe.filter((branch: { ID: any; }) => branch.ID == (item.value ?? item))[0]?.Name;
      this._camService.getCorporateCards(this.sauserId, item?.value ?? item).then((res) => {
        this.bindLists('associatedRuleAppliedOn', res.data.GetRuleAppliesOnValue);
        this.ruleAppliedFor.setValue(null);
        this.filteredAssocatedWithRule = this.ruleAppliedFor.valueChanges.pipe(
          startWith(null),
          map((value: string | null) => {
            if (typeof value === 'string') {
              return this._filter(value);
            } else {
              return this.commonObjPipes.associatedRuleAppliedOn.pipe.slice();
            }
          })
        );

        resolve(); // Resolve the promise once data is loaded
      }).catch((error) => {
        reject(error); // Reject the promise if there's an error
      });
    });
  }
  onRuleAppliedOnChange(item: any, isEditMode: boolean = false): Promise<void> {
    this.associateRuleName = [];

    return new Promise((resolve, reject) => {

      const ruleId = item?.value ?? item;

      this.ruleAppliedOnName = this.commonObjPipes.GetRuleAppliesOn.pipe
        .find((branch: { ID: any }) => branch.ID == ruleId)?.Name;

      this._camService.getCorporateCards(this.sauserId, ruleId).then((res) => {

        this.bindLists('associatedRuleAppliedOn', res.data.GetRuleAppliesOnValue);

        // ✅ Only reset when user manually changes rule
        if (!isEditMode) {
          this.ruleAppliedFor.setValue(null);
          this.selectedAssoicatedRuleIdMap = {};
          this.associateRuleName = [];
        }

        this.filteredAssocatedWithRule = this.ruleAppliedFor.valueChanges.pipe(
          startWith(null),
          map((value: string | null) => {
            if (typeof value === 'string') {
              return this._filter(value);
            } else {
              return this.commonObjPipes.associatedRuleAppliedOn.pipe.slice();
            }
          })
        );

        resolve();

      }).catch((error) => {
         const message =
          error?.error?.message ||
          error?.message ||
          'Something went wrong. Please try again.';
        this._CompanyManagementService.view_error_message(message,error?.code);
        reject(error);
      });

    });
  }


  onCheckboxChange(event: any, branch: any, parentClass: string, matAutoClassRef: string) {

    this.selectedAssoicatedRuleIdMap[branch.ID] = event.checked;

    if (event.checked) {
      if (!this.associateRuleName.includes(branch.Name)) {
        this.associateRuleName.push(branch.Name)

      }
    } else {
      this.associateRuleName = this.associateRuleName.filter(name => name.toLocaleLowerCase().trim() != branch.Name.toLocaleLowerCase().trim());

    }

    const selectedAssociatedRuleId = Object.keys(this.selectedAssoicatedRuleIdMap)
      .filter(key => this.selectedAssoicatedRuleIdMap[parseInt(key)])

    this.ruleAppliedFor.setValue(selectedAssociatedRuleId.join(','));
    this.ruleAppliedFor.updateValueAndValidity();
    this.corporateCardForm?.get('ruleAppliedFor')?.setValue(selectedAssociatedRuleId.join(','));
    this.corporateCardForm?.get('ruleAppliedFor')?.updateValueAndValidity();

    requestAnimationFrame(() => this.CustomMatAutoPosition(parentClass, matAutoClassRef));

  }


  CustomMatAutoPosition(parentClass: string, matAutoClassRef: string) {
    let parent = (document.querySelector(`.${parentClass}`) as HTMLDivElement).getBoundingClientRect();
    (document.querySelector('.cdk-overlay-connected-position-bounding-box .cdk-overlay-pane') as HTMLDivElement)?.style.setProperty('top', `${parent.top + parent.height}px`, 'important');
    // (document.querySelector(`.${matAutoClassRef}`) as HTMLDivElement).style.marginTop = `${parent.top + parent.height}px`;
  }

  optionClicked(branch: any) {
    // Toggle the checkbox state
    const newCheckedState = !this.selectedAssoicatedRuleIdMap[branch.ID];

    // Create a mock event object that matches what the checkbox change expects
    const mockEvent = {
      checked: newCheckedState,
      stopPropagation: () => { } // Add empty function to prevent errors
    };

    // Call your existing checkbox handler with the toggled state
    this.onCheckboxChange(mockEvent, branch, 'custom-mat-dropdown-parent', 'custom-autocomplete');
  };

  addNewCorporateCard(template?: TemplateRef<any>) {
    if (template && this.getUserRole() === 'Admin') {
      this.dialog.open(template, {
        // panelClass: 'custom-popup-gen-policy-filter-popup',
        width: '638px',
        disableClose: false,
        autoFocus: false
      });
    }
    this.Addnew = true
    this.corporateCardForm.reset({
      queryNo: 1,
      guid: null,
      isVirtualCard: true,
      islodge: true,
    })
    this.selectedAssoicatedRuleIdMap = {};
    this.associateRuleName = [];

    this.corporateCardForm.markAsPristine(); // Reset validation state
    this.corporateCardForm.markAsUntouched(); // Remove touched states
    this.corporateCardForm.updateValueAndValidity(); // Ensure changes take effect
    this._CompanyManagementService.company_management_corporateCard('Add link','Add', this.commonObjPipes.GetAllCorporateCardDetails.pipe.length)//GTM use
  }

  onCancel() {
    this.Addnew = false;
    this.editMode = false;
    this.isCardMasked = false;
    this.originalCardNumber = '';
    // Restore full validators on cardNumber in case they were cleared during edit
    this.corporateCardForm.get('cardNumber')?.setValidators([Validators.required, luhnValidator()]);
    this.corporateCardForm.get('cardNumber')?.updateValueAndValidity({ emitEvent: false });
    this._CompanyManagementService.company_management_corporateCard('Cancel button','Cancel', this.commonObjPipes.GetAllCorporateCardDetails.pipe.length)//GTM use

  }

  // Initialize months and years
  initializeMonthsAndYears() {
    this.months = Array.from({ length: 12 }, (_, i) => ({
      index: i,
      value: new Date(2000, i).toLocaleString('en-US', { month: 'short' }).toUpperCase(), // 'Jan', 'Feb', etc.
      name: new Date(2000, i).toLocaleString('en-US', { month: 'long' })   // 'January', 'February', etc.
    }));
    const currentYear = new Date().getFullYear();
    this.years = Array.from({ length: 11 }, (_, i) => ({
      value: currentYear + i,
      isDisabled: false
    }));
  }

  // Validator for expiry date
  checkPastMonth() {
    let expiryMonth = this.corporateCardForm.get('expiryMonth')?.value;
    const currentMonth = new Date().getMonth() + 1; // JavaScript months are 0-based
    // Convert month abbreviation to numeric month
    const monthMapping: { [key: string]: number } = {
      JAN: 1, FEB: 2, MAR: 3, APR: 4, MAY: 5, JUN: 6,
      JUL: 7, AUG: 8, SEP: 9, OCT: 10, NOV: 11, DEC: 12
    };
    expiryMonth = monthMapping[expiryMonth]; // Convert "JAN" -> 1
    let currentYear = new Date().getFullYear();
    if (expiryMonth < currentMonth) {
      currentYear++; // Move to next year if the selected month is in the past
    }
    // Generate years from the determined starting year
    this.years = Array.from({ length: 11 }, (_, i) => ({
      value: currentYear + i,
      isDisabled: false
    }));
  }

  onSave() {
    const formData = this.corporateCardForm.value;
    const isUpdate = formData.queryNo == 2;
    // If card is still masked (user didn't edit it), send the original unmasked number
    if (this.isCardMasked && this.originalCardNumber) {
      formData.cardNumber = this.originalCardNumber;
    } else {
      formData.cardNumber = formData.cardNumber.replace(/-/g, '');
    }

    this._CompanyManagementService.company_management_corporateCard('Save button','Save', this.commonObjPipes.GetAllCorporateCardDetails.pipe.length)//GTM use

    this._camService.insertUpdateCorporateCard(this.sauserId, formData).then((res) => {
      if (res.status == "Success") {
        this.getCorporateCardsList()
        this.Addnew = false
        this.editMode = false
        this.isCardMasked = false;
        this.originalCardNumber = '';
        // Restore full validators after save
        this.corporateCardForm.get('cardNumber')?.setValidators([Validators.required, luhnValidator()]);
        // Show appropriate message based on operation type
        const message = isUpdate
          ? 'Corporate card has been updated successfully!'
          : 'Corporate card has been saved successfully!';

        this._ToastrApiService.show('success', message);
        this._CommonService.formResetTrigger(); //to reset the form
        this.corporateCardForm.reset({
          queryNo: 1,
          guid: null,

        })

        this._CompanyManagementService.save_success('Corporate cards', 'Success')//GTM use

      }
      if (res.status == "Failed") {
        // this._ToastrApiService.show('error', res.message +'.');
        this._ToastrApiService.show('error', 'This card is already saved with Saudia Business.');
        this._CommonService.formResetTrigger();
        this.corporateCardForm.reset({
          queryNo: 1,
          guid: null,

        })
      }

    }).catch((error) => {
       const message =
          error?.error?.message ||
          error?.message ||
          'Something went wrong. Please try again.';
      this._CompanyManagementService.view_error_message(message,error?.code);
      console.error(error)
    })
  }


  onEdit(item: any) {
    this.Addnew = true;
    this.editMode = true;
    this._CompanyManagementService.company_management_corporateCard('Edit button','Edit', this.commonObjPipes.GetAllCorporateCardDetails.pipe.length)//GTM use

    this._camService.getCorporateCardByID(this.sauserId, item.GUID).then((res) => {
      if (res.status == "Success") {
        const appliedForArray = res.data[0].Applied_For
          ? res.data[0].Applied_For.split(',') // Convert CSV to array
          : [];

        const fullCardNumber = res.data[0].Card_Number;
        const maskedCardNumber = fullCardNumber.replace(/^(\d{4})\d+(\d{4})$/, '$1********$2');
        this.originalCardNumber = fullCardNumber; // store for save

        this.corporateCardForm.patchValue({
          queryNo: 2,
          guid: res.data[0].GUID,
          cardName: res.data[0].Corporate_CardName,
          cardOption: res.data[0].CorporateCardType,
          cardType: res.data[0].Card_Type,
          cardHolderName: res.data[0].Name_on_Card,
          cardNumber: maskedCardNumber,
          expiryMonth: res.data[0].Exp_Month,
          expiryYear: res.data[0].Exp_Year,
          isVirtualCard: res.data[0].Is_Virtual_Card,
          islodge: res.data[0].Is_Lodge_Card,
          isChargeAtMerchant: res.data[0].Charge_At_Merchant,
          ruleAppliedOn: res.data[0].Applied_On,
          product: res.data[0].Product,
          ruleAppliedFor: appliedForArray.join(','),
          isPersonalCard: res.data[0].IsPersonal
        });

        // Card number is masked — skip Luhn/type/length validators until user edits the field
        this.isCardMasked = true;
        this.corporateCardForm.get('cardNumber')?.clearValidators();
        this.corporateCardForm.get('cardNumber')?.setErrors(null);
        this.corporateCardForm.get('cardNumber')?.updateValueAndValidity({ emitEvent: false });

        // Call onRuleAppliedOnChange and wait for it to complete
        this.onRuleAppliedOnChange(res.data[0].Applied_On, true).then(() => {
          // Now populate the associateRuleName array
          this.selectedAssoicatedRuleIdMap = {};
          this.associateRuleName = [];

          appliedForArray.forEach((Id: any) => {
            this.selectedAssoicatedRuleIdMap[Id] = true;
            const assoRuleName = this.commonObjPipes.associatedRuleAppliedOn.pipe.find((b: { ID: any; }) => b.ID == Id);
            if (assoRuleName) {
              this.associateRuleName.push(assoRuleName.Name);
            }
          });
        });
      }
    }).catch((error) => {
      const message =
          error?.error?.message ||
          error?.message ||
          'Something went wrong. Please try again.';
      this._CompanyManagementService.view_error_message(message,error?.code);
      console.error(error);
    });
  }


  onRemove(item: any) {
    this._CompanyManagementService.company_management_corporateCard('Remove button','Remove', this.commonObjPipes.GetAllCorporateCardDetails.pipe.length)//GTM use

    this.currentItem = item;
    const dialogRef = this.dialog.open(this.selectionWarning, {
      data: item, // Pass the item data
    });
  }

  confirmDelete(item: any) {

    this._camService.deleteCorporateCard(item.CardID).then((res) => {
      if (res.status == "Success") {
        this._ToastrApiService.show('success', 'Corporate card has been removed successfully!');
        this._CompanyManagementService.corporateCard_remove_Successfully('Confirm','Success')//GTM use
        this.currentItem = undefined;
        this.getCorporateCardsList()
      }
    }).catch((error) => {
      const message =
          error?.error?.message ||
          error?.message ||
          'Something went wrong. Please try again.';
      this._CompanyManagementService.view_error_message(message,error?.code);
      console.error(error)
    })
  }

  CloseDialog(result: boolean) {
    if (result) {
      this.confirmDelete(this.currentItem)
      this._CompanyManagementService.corporateCard_remove('Proceed', 'Are you sure you want to remove this corporate cards?')
    }

    if (!result) {
      this._CompanyManagementService.corporateCard_remove('Cancel', 'Are you sure you want to remove this corporate cards?')

    }
    this.dialog.closeAll(); // Closes the dialog
  }

  atLeastOneCheckboxValidator(group: FormGroup) {
    const islodge = group.get('islodge')?.value;
    const isChargeAtMerchant = group.get('isChargeAtMerchant')?.value;

    return islodge || isChargeAtMerchant ? null : { atLeastOneRequired: true };
  }


  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
  }

  blockInvalidCharacters1(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', ':', '$', '|', '[', ']', '~', '--', '@', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }
  // Block non-numeric input
  allowedNumberOnly(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }


  // chips dropdown methods
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      // this.associateRuleName.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.ruleAppliedFor.setValue(null);
  }

  remove(name: string): void {
    const index = this.associateRuleName.indexOf(name);

    if (index >= 0) {
      this.associateRuleName.splice(index, 1);
      this.announcer.announce(`Removed ${name}`);

      const associateRule = this.commonObjPipes.associatedRuleAppliedOn.pipe.find((rule: { Name: string; }) => rule.Name.toLocaleLowerCase().trim() == name.toLocaleLowerCase().trim());
      if (associateRule) {
        this.selectedAssoicatedRuleIdMap[associateRule.ID] = false;
        const selectedAssoRule = Object.keys(this.selectedAssoicatedRuleIdMap).filter(key => this.selectedAssoicatedRuleIdMap[parseInt(key)]);
        this.corporateCardForm.controls['ruleAppliedFor'].setValue(selectedAssoRule.join(','));
        this.corporateCardForm.controls['ruleAppliedFor'].updateValueAndValidity();
      }
    }
  }


  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.commonObjPipes.associatedRuleAppliedOn.pipe.filter((cateory: { Name: string; }) => cateory.Name.toLowerCase().includes(filterValue));
  }


  checkCardTypeValidation() {
    // Skip validation when card number is still masked (edit mode, unchanged by user)
    if (this.isCardMasked) return;

    const rawCardNumber = this.corporateCardForm.get('cardNumber')?.value;
    const cardNumber = rawCardNumber ? rawCardNumber.replace(/-/g, '') : ''; // Remove hyphens
    const cardType = this.corporateCardForm.get('cardType')?.value;

    if (!cardNumber || !cardType) return;

    const patterns: any = {
      'VI': /^4/,
      'CA': /^(5[1-5]|2[2-7])/,
      'AX': /^3[47]/
    };

    const lengths: any = {
      'VI': [13, 16, 19],
      'CA': [16],
      'AX': [15]
    };

    const cardTypeNames: any = {
      'VI': 'Visa',
      'CA': 'MasterCard',
      'AX': 'American Express'
    };

    const isValidPattern = patterns[cardType]?.test(cardNumber);
    const isValidLength = lengths[cardType]?.includes(cardNumber.length);

    // Clear previous errors first
    const currentErrors = this.corporateCardForm.get('cardNumber')?.errors;
    let newErrors = { ...currentErrors };

    if (currentErrors?.['invalidCardType']) {
      delete newErrors['invalidCardType'];
    }
    if (currentErrors?.['invalidLength']) {
      delete newErrors['invalidLength'];
    }

    if (!isValidPattern) {
      newErrors['invalidCardType'] = true;
    }

    if (!isValidLength) {
      newErrors['invalidLength'] = {
        requiredLength: lengths[cardType],
        actualLength: cardNumber.length, // Use cleaned number length
        cardType: cardTypeNames[cardType]
      };
    }

    // Set errors or clear if no errors
    if (Object.keys(newErrors).length > 0) {
      this.corporateCardForm.get('cardNumber')?.setErrors(newErrors);
    } else {
      this.corporateCardForm.get('cardNumber')?.setErrors(null);
    }
  }

  //Card type length Validation 
  checkCardLength(): string {
    const rawCardNumber = this.corporateCardForm.get('cardNumber')?.value;
    const cardNumber = rawCardNumber ? rawCardNumber.replace(/-/g, '') : '';

    const lengthError = this.corporateCardForm.get('cardNumber')?.errors?.['invalidLength'];
    if (!lengthError) return '';

    const requiredLength = lengthError.requiredLength;
    const actualLength = cardNumber.length; // Use cleaned number length
    const cardType = lengthError.cardType;

    if (Array.isArray(requiredLength)) {
      const lengthText = requiredLength.join(', ');
      return `${cardType} card must be ${lengthText} digits long. Current length: ${actualLength}`;
    }

    return `${cardType} card must be ${requiredLength} digits long. Current length: ${actualLength}`;
  }
  sitecoreGetWarningMessage(messageId: string): any {
    return this.content?.warningList?.find(
      (item: any) => item.messageID === messageId
    );
  }
  getUserRole(): string {
    const travelArranger = this.crypto.getValueFromKey(
      'ISCORPTRAVELARRANGER'
    ) as string;

    switch (travelArranger) {
      case '0':
        return 'Admin';
      case '1':
        return 'TravelArranger';
      case '2':
        return 'Employee';
      default:
        return '';
    }
  }

  onNoDomainPopupContinue(): void {
    this.dialog.closeAll();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
